import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ProductService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { DealerPrice } from 'src/app/model/dealer-price.model';
import { Category } from 'src/app/model/product.model';
import { DealerPriceService } from 'src/app/service/dealer-price/dealer-price.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import { CustomProductService } from 'src/app/service/product/custom-product.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { CurrentBusinessType } from 'src/app/utility/current-businesstype';
import { ShimanoUtilMethod } from 'src/app/utility/methods.util';

@Component({
  selector: 'app-notify-me-modal',
  templateUrl: './notify-me-modal.component.html',
  styleUrls: ['./notify-me-modal.component.scss'],
  standalone: false,
})
export class NotifyMeModalComponent implements OnInit {
  products: any;

  product$: any[] = [];
  variant$: any[] = [];
  productCodesList: any[] = [];
  dealerPrices: DealerPrice[];
  categoryNames: any[] = [];
  parentVariantNames: any;
  showCategory: boolean = true;
  showSrp = false;
  variantValueCategoryCount: number;
  businessType: string;

  constructor(
    protected customProductService: CustomProductService,
    private productService: ProductService,
    private modalService: StandardModalService,
    private dealerPriceService: DealerPriceService,
    private cdr: ChangeDetectorRef,
    private storageService: StorageService,
    private currentBusinessType: CurrentBusinessType
  ) {
    this.modalService
      .getModalData()
      .pipe(take(1))
      .subscribe((res) => {
        this.products = res.products;
      });
  }

  ngOnInit(): void {
    this.businessType = this.currentBusinessType.getBusinessType();
    this.getInitSrpToggleValue();
    this.removeDuplicate(this.products);
    this.setProduct(this.products);
    this.cdr.detectChanges();
  }

  getInitSrpToggleValue() {
    this.showSrp = this.storageService.getLocalStorageItem('showSrp') === 'true';
  }

  setProduct(products: any[]) {
    products.forEach((product: any) => {
      if (product && product.notifyMe) {
        const variantValueCategory = product.superCategories;
        const variantValueCategoryCount = this.getValueVariantCategoryCount(variantValueCategory);
        if (variantValueCategoryCount == 1) {
          this.showCategory = false;
        }
        if (variantValueCategoryCount > 1) {
          const parentVariantNameSet = new Set();
          for (const variant of product.variantMatrix) {
            for (const element of variant.elements) {
              if (element.parentVariantCategory) {
                parentVariantNameSet.add(element.parentVariantCategory.name);
              }
              if (element.elements && element.elements.length > 0) {
                for (const innerElement of element.elements) {
                  if (innerElement.parentVariantCategory) {
                    parentVariantNameSet.add(innerElement.parentVariantCategory.name);
                  }
                }
              }
            }
          }
          this.categoryNames.push([...parentVariantNameSet]);
        }
        this.productCodesList.push(product.code);
        this.variant$.push(product);
      }
    });
    this.getDealerPrices(this.productCodesList);
  }

  getValueVariantCategoryCount(superCategories: Category[]) {
    return superCategories.filter((superCategory) => superCategory.type === 'VariantValueCategory').length;
  }

  getProduct(productCode: string): Observable<any> {
    return this.productService.get(productCode).pipe(filter(Boolean));
  }

  getImageRendition(image: any) {
    let size: string;
    size = ShimanoUtilMethod.imageRendition(80);
    return ShimanoUtilMethod.newImageFormat(image, size);
  }

  getDealerPrices(productCodes: string[]) {
    this.dealerPriceService
      .getDealerPricesByProductCodes(productCodes)
      .pipe(take(1))
      .subscribe((data) => {
        this.dealerPrices = data.dealerPrices;
        this.cdr.detectChanges();
      });
  }

  dealerPrice(productCode: string): string {
    if (this.dealerPrices) {
      return this.dealerPriceService.getDealerPriceByProductCode(this.dealerPrices, productCode);
    }
  }

  closeModal(reason: any): void {
    this.modalService.closeDialog(reason);
  }

  productCategories(superCategories: any[], categoryNames: string[]) {
    const values = [];
    for (const superCategory of superCategories) {
      if (categoryNames.includes(superCategory.parentCategoryName)) {
        values.push(superCategory.name);
      }
    }
    return values;
  }
  compareCodes(variantSuperCategories: any[], productSuperCategories: any[], product: any): boolean {
    const parentCategoryName = product.variantMatrix[0].parentVariantCategory.name;
    const variantCode = variantSuperCategories.find(
      (category) => category.parentCategoryName === parentCategoryName
    )?.code;
    const productCode = productSuperCategories.find(
      (category) => category.parentCategoryName === parentCategoryName
    )?.code;
    return productCode === variantCode;
  }

  removeDuplicate(array: any[]) {
    const uniqueArray: any[] = [];
    const map = new Map();
    array.forEach((item) => {
      for (const superCategory of item.superCategories) {
        if (superCategory.parentCategoryName === item.variantMatrix[0].parentVariantCategory.name) {
          if (!map.get(superCategory.code)) {
            map.set(superCategory.code, superCategory.code);
            uniqueArray.push(item);
          }
        }
      }
    });
    this.product$ = uniqueArray;
  }
}
